import "./Workcardstyle.css";
import React from 'react';
import my from "../assets/mine.jpg"
import { NavLink } from "react-router-dom";
const Projectworkcard = (props) => {
  return (
    <div className="role-card">
    <img src={props.imgsrc} alt="image"/>
    <h2 className="title" align="center">{props.title}</h2>
    <div className="details">
      <p>{props.text}</p>
      
      <div className="p-btns">
        <NavLink to={props.view1} className="btn">view</NavLink>

        <NavLink to="url.com" className="btn">Research</NavLink>
      </div>
      </div>
      </div>

      
    
  )
}

export default Projectworkcard;
